import React from "react";
import * as Layout from 'react-bootstrap';
import Logo from '../../../assets/logo.png';

const Header = () => {
    /*** Return output ***/
    return (
        <Layout.Navbar className="mb-3">
            <Layout.NavbarBrand>
                <Layout.NavLink href="/">
                    <img src={Logo} alt="CometQR" style={{ maxHeight: '56px', width: 'auto', maxWidth: '100%' }} />
                </Layout.NavLink>
            </Layout.NavbarBrand>
            <Layout.Navbar.Toggle aria-controls="app-navigation" />
            <Layout.Navbar.Collapse id="app-navigation" className="justify-content-end">
            </Layout.Navbar.Collapse>
        </Layout.Navbar>
    );
}

export default Header;
